import React from 'react'
import Typical from 'react-typical'
import {useStyles} from './styles';

const steps = [
  'I am a full stack developer 👋', 1000,
  'I have several skills ', 1000,
  'Node.js and Express.js 👌', 1000,
  'React.js, React native and Ejs 👌', 1000,
  'Mongo DB and Mysql', 1000,
  'I am open to work with you', 1000,
  'Let\'s get in touch ', 1000,
];

const Home = () => {
    const classes = useStyles();
    return (
        <div className={classes.homeContainer}>
            <div className={classes.content}>
                
            
                <h1 >Hello, I'am MOHAMMED NAJJAR</h1>
                <div>
                    <Typical wrapper="h3" steps={steps} loop={1} />
                </div>

            </div>
        </div>
    )
}

export default Home
